export enum SupportedConnectors {
    METAMASK = 'Metamask',
    WALLET_CONNECT = 'WalletConnect',
    COINBASE = 'Coinbase Wallet',
    TREZOR = 'Trezor',
    PORTIS = 'Portis',
    LEDGER = 'Ledger',
    TORUS = 'Torus',
    FORTMATIC = 'Formatic',
}
